// Function to send Mixpanel events
function ofhMixpanelTrack( event, addedProperties = {} ) {

  let properties = Object.assign(
    {
      'page_url' : window.location.href,
      'page_path': window.location.pathname,
      'page_language': ofh_language_get( true ),
      'page_domain_name': 'public'
    },
    addedProperties
  );

  if ( typeof mixpanel !== 'undefined' && typeof mixpanel.track !== 'undefined' ) {

    mixpanel.track( event, properties )

  }

}



// Links
// :not( [ class*="menu-link-top" ] ) is to exclude navigation menu / mobile toggle
// which are tracked in their respective components
document.querySelectorAll( 'a:not( [ class*="menu-link-top" ] )' ).forEach( function( ofhNodeToTrack ) {

  // Add a click event listener
  ofhNodeToTrack.addEventListener( 'click', function( event ) {

    // Stop the link being followed
    event.preventDefault();

    // Stop the event bubbling
    // This is to stop things like card links triggering two events
    event.stopPropagation();

    // Get the clicked link element
    let clickedElement = event.currentTarget;

    // Get the destination url of the clicked link
    let link_destination_url = clickedElement.getAttribute( 'href' );

    // Join Button Clicked
    if (
      clickedElement.innerText.toLowerCase().startsWith( 'join' ) ||
      clickedElement.innerText.toLowerCase().startsWith( 'ymuno' )
    ) {

      let button_name = clickedElement.innerText;

      ofhMixpanelTrack(
        'Join Button Clicked',
        {
          'button_name': button_name,
          'link_source_url': window.location.href,
          'referrer_site_domain_name': 'public',
          'destination_site_domain_name': 'study'
        }
      );
    }

    // User Sign In Clicked
    if ( clickedElement.innerText.toLowerCase() === 'sign in' ) {
      ofhMixpanelTrack( 'User Sign In Clicked' );
    }

    // Navigation Menu Clicked
    // Desktop items tracked in /components/header/header-desktop-front.js
    // Mobile menu button tracked in /components/header/header-mobile-front.js
    if ( clickedElement.classList.contains( 'menu-link-child' ) ) {

      let navigation_menu_section = clickedElement.closest( '.menu-item-top' ).querySelector( '.menu-link-top' ).innerText;

      let navigation_menu_item = clickedElement.innerText;

			ofhMixpanelTrack(
				'Navigation Menu Clicked',
				{
					'navigation_menu_section': navigation_menu_section,
					'navigation_menu_item': navigation_menu_item
				}
			);
    }

    // Cross-domain Navigation
    if (
      link_destination_url.indexOf( '.ourfuturehealth.org.uk' ) !== -1 &&  // URL is on an OFH subdomain
      link_destination_url.indexOf( 'http' ) !== -1 // It's a website URL, not e.g. an email address
    ) {

      let destination_site_domain_name = '';

      destination_site_domain_name = link_destination_url.split( '.ourfuturehealth.org.uk' )[ 0 ].split( '//' )[ 1 ];

      ofhMixpanelTrack(
        'Cross-domain Navigation',
        {
          'referrer_site_domain_name': 'public',
          'destination_site_domain_name': destination_site_domain_name
        }
      );
    }

    // Home Button Clicked
    if (
      clickedElement.classList.contains( 'logo-link' ) ||
      ( clickedElement.classList.contains( 'ofh-breadcrumb__link' ) && clickedElement.innerText === 'Home' )
    ) {

      let properties;

      if ( clickedElement.classList.contains( 'logo-link' ) ) { properties = { 'header_logo': true } }
      else { properties = { 'header_logo': false } }

      ofhMixpanelTrack( 'Home Button Clicked', properties );

    }

    // PDF Downloaded
    if ( link_destination_url.indexOf( '.pdf' ) !== -1 ) {

      let pdf_name = clickedElement.innerText;

      let pdf_language = 'EN';

      if (
        document.querySelector( '#ofh-language-switcher' ) !== null &&
        ofh_language_get() == 'cy'
      ) {
        pdf_language = 'CY'
      }

      ofhMixpanelTrack(
        'PDF Downloaded',
        {
          'pdf_name': pdf_name,
          'pdf_language': pdf_language
        }
      );
    }

    // Information Button Clicked
    if (
      (
        clickedElement.classList.contains( 'ofh-action-link__link' ) || // Action link or
        (
          clickedElement.classList.contains( 'ofh-button' ) && // a button and
          ( // one of these types:
            clickedElement.closest( '.ofh-mosaic-promo' ) !== null ||
            clickedElement.closest( '.ofh-intro-landing' ) !== null ||
            clickedElement.closest( '.ofh-cta-two-column' ) !== null ||
            clickedElement.closest( '.ofh-cta' ) !== null
          )
        )
      ) && (
        ! clickedElement.innerText.toLowerCase().startsWith( 'join' ) && // Not a join link in English and
        ! clickedElement.innerText.toLowerCase().startsWith( 'ymuno' ) && // not a join link in Welsh and
        link_destination_url.indexOf( 'http' ) !== -1 // it's a website URL, not e.g. an email address
      )
    ) {

      let button_name = clickedElement.innerText;

      ofhMixpanelTrack(
        'Information Button Clicked',
        {
          'button_name': button_name
        }
      );
    }

    // Footer Link Clicked
    if ( clickedElement.classList.contains( 'ofh-footer__list-item-link' ) ) {

      ofhMixpanelTrack(
        'Footer Link Clicked',
        {
          'link_destination_url': link_destination_url
        }
      );
    }

    // Contact Link Clicked
    if (
      link_destination_url.indexOf( 'mailto:' ) !== -1 ||
      link_destination_url.indexOf( 'tel:' ) !== -1
     ) {

      let link_type = '';
      if      ( link_destination_url.indexOf( 'mailto:' ) !== -1 ) { link_type = 'email' }
      else if ( link_destination_url.indexOf( 'tel:' ) !== -1 )    { link_type = 'telephone' }

      let action_type = '';
      if      ( link_destination_url.indexOf( 'access@' ) !== -1 )       { action_type = 'Access' }
      else if ( link_destination_url.indexOf( 'complaint@' ) !== -1 )    { action_type = 'Complaint' }
      else if ( link_destination_url.indexOf( 'info@' ) !== -1 )         { action_type = 'General Enquiries' }
      else if ( link_destination_url.indexOf( 'media@' ) !== -1 )        { action_type = 'Media Enquiries' }
      else if ( link_destination_url.indexOf( 'partnerships@' ) !== -1 ) { action_type = 'Partnerships' }

      let contact_detail = link_destination_url.split( ':' )[ 1 ];

      ofhMixpanelTrack(
        'Contact Link Clicked',
        {
          'link_type' : link_type,
          'action_type' : action_type,
          'contact_detail' : contact_detail
        }
      );
    }

    // Social Media Icon Clicked
    if ( clickedElement.classList.contains( 'social-link' ) ) {

      let icon_name = '';

      if      ( link_destination_url.indexOf( 'linkedin.com' ) !== -1 )  { icon_name = 'LinkedIn'; }
      else if ( link_destination_url.indexOf( 'x.com' ) !== -1 )         { icon_name = 'X'; }
      else if ( link_destination_url.indexOf( 'facebook.com' ) !== -1 )  { icon_name = 'Facebook'; }
      else if ( link_destination_url.indexOf( 'youtube.com' ) !== -1 )   { icon_name = 'YouTube'; }
      else if ( link_destination_url.indexOf( 'instagram.com' ) !== -1 ) { icon_name = 'Instagram'; }
      else if ( link_destination_url.indexOf( 'tiktok.com' ) !== -1 )    { icon_name = 'TikTok'; }

      ofhMixpanelTrack(
        'Social Media Icon Clicked',
        {
          'icon_name' : icon_name
        }
      );
    }

    // Wait for 100ms before following the link so the tracking has time to take effect
    setTimeout(
      function() {
        window.location.href = link_destination_url;
      },
      100
    );

  } );

} );



// Accordions
document.querySelectorAll( 'summary' ).forEach( function( ofhNodeToTrack ) {

  // Add a click event listener
  ofhNodeToTrack.addEventListener( 'click', function( event ) {

    let language_target = '.ofh-details__summary-text.lang-en';

    if (
      document.querySelector( '#ofh-language-switcher' ) !== null &&
      ofh_language_get() == 'cy'
    ) {
      language_target = '.ofh-details__summary-text.lang-cy';
    }

    // Get summary text
    let information_module_name = event.currentTarget.querySelector( language_target ).innerText.trim();

    // Was this to expand the details
    // This is measured before the action, so a return of "true"
    // means that it was open, but is now closed
    let expanded = ! event.currentTarget.parentNode.hasAttribute( 'open' );

    // Information Module Opened
    ofhMixpanelTrack(
      'Information Module Opened',
      {
        'information_module_name' : information_module_name,
        'module_expanded' : expanded
      }
    );

  } );

} );
